import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './Produto.css';
import ContentContainer from 'components/ContentContainer';
import Button from 'components/Button';
import client from 'util/datocms';
import NaoEncontrada from 'pages/NaoEncontrada';

export default function Produto() {
  const { id } = useParams();
  const [produto, setProduto] = useState(null);

  useEffect(() => {
    const fetchProduto = async () => {
      try {
        const query = `
          {
            produto(filter: { id: { eq: "${id}" } }) {
              id
              titulo
              categoria
              link
              imagem {
                url
              }
              descricao
            }
          }
        `;

        const { produto } = await client.request(query);
        setProduto(produto);
      } catch (error) {
        console.error('Erro ao obter o produto:', error);
      }
    };

    fetchProduto();
  }, [id]);
  

  if (!produto) {
    return <NaoEncontrada />;
  }

  return (
    <>
      <ContentContainer>
        <div className='product-area'>
          <div className='product-box'>
            <img src={produto.imagem.url} alt={produto.titulo} />
          </div>
          <div className='descricao-compra'>
            <h1 className='titulo-compra'>{produto.titulo}</h1>
            <h3 className='desc-produto'>Descrição do produto</h3>
            <p>{produto.descricao}</p>
            <div className='produto-btns'>
              <Link to={produto.link} target='_blank' style={{textDecoration:'none'}}>
              <Button className="btn-teste">
                Ver na loja
              </Button>
              </Link>
              <Link to="https://wa.me/5513981345668" target='_blank' style={{textDecoration:'none'}}>
                <Button>
                  Entre em contato
                </Button>
              </Link>
            </div>
            
            
          </div>
        </div>
      </ContentContainer>
    </>
  )
}
